import DictApi from '@/api/dict';
import Field from '@/packages/field';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'Position' })
export default class Position extends Vue {
  @Prop()
  private value!: number | undefined;

  // 职务
  private position: number | undefined | null = null;

  private errorMsg = '';

  private created() {
    if (this.value) {
      this.position = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.position) {
      this.position = val;
    }
  }

  public onValidator(): boolean {
    if (this.position === undefined || this.position === null) {
      this.errorMsg = '请选择职务';
      return false;
    }

    return true;
  }

  private onChangeRegistration(val: number | undefined | null) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.Position}>
        <Field
          v-model={this.position}
          label="职务"
          sub={true}
          onChange={() => this.onChangeRegistration(this.position)}
          type="select"
          dictApi={DictApi.getPosition}
          error={this.errorMsg}
          readonly={true}
        />
      </div>
    );
  }
}
